// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"188612c6","453":"0f11083b","484":"1973d638","627":"536c5990","738":"40cad89f","923":"af14cab5"}[chunkId] + ".chunk.js";
};